import React from 'react'
import specialmenu from "../images/special menu.jpeg";
import food from "../images/food.jpeg";
import chicken from "../images/food page.jpeg";
import paneer from "../images/paneer.jpeg";
import chickenkosha from "../images/chicken (2).jpeg";
import chickenfried from "../images/fried.jpeg";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import rice from "../images/rice (2).jpeg";
import chickenpokora from "../images/chiken pokora.jpeg";
import cutlet from "../images/cutlet.jpeg";
import chickenmenu from "../images/chicken.jpeg";
import pokora from "../images/pakora.jpeg";
import specialdish from "../images/egg omlet.jpeg";
import thali from "../images/thali.jpeg";
import fish from "../images/fish.jpeg";
import tandooriroti from "../images/tandoori roti.jpeg";
import chickenplate from "../images/chiken.jpeg"
import chickenkari from "../images/chicken kari photo.jpeg"
import panerphoto from "../images/paneer food.jpeg"
import elishfish from "../images/Elish Fish.jpeg";
import chickenmenup from "../images/Chicken malai.jpeg"
import motor from "../images/Motor.jpeg";
import foodp from "../images/food plate.jpeg"
import egg from "../images/eeg.jpeg"
import ricewithghee from "../images/rice with ghee.jpeg";
import kabab from "../images/kabab.jpeg";
import biriyani from "../images/Biriyani.jpeg";
import chickepakora from "../images/chicken pokora.jpeg"
import ricemenu from "../images/rice menu.jpeg"
function Food() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <h1>Our <b style={{ color: "#3D2219" }}> Food</b></h1>
                    <div className="row">

                        <div className="col-md-4 mt-2">
                            <img src={specialmenu} className="card-img-top" alt="specialmenu" />

                        </div>
                        <div className="col-md-4 mt-2">
                            <img src={food} className="card-img-top" alt="food" />

                        </div>
                        <div className="col-md-4 mt-2">
                            <img src={chicken} className="card-img-top" alt="chicken" />

                        </div>
                        <div className="col-md-4 mt-2">
                            <img src={paneer} className="card-img-top" alt="paneer" />

                        </div>
                        <div className="col-md-4 mt-2">
                            <img src={chickenkosha} className="card-img-top" alt="chickenkosha" />

                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={chickenfried} className="card-img-top" alt="chickenfried" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={rice} className="card-img-top" alt="rice" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={chickenpokora} className="card-img-top" alt="chickenpokora" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={cutlet} className="card-img-top" alt="cutlet" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={chickenmenu} className="card-img-top" alt="chicken" />
                            </Zoom>
                        </div>
                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={pokora} className="card-img-top" alt="pokora" />
                            </Zoom>
                        </div>


                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={specialdish} className="card-img-top" alt="specialdish" />
                            </Zoom>
                        </div>




                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={fish} className="card-img-top" alt="fish" />
                            </Zoom>
                        </div>
                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={thali} className="card-img-top" alt="thali" />
                            </Zoom>
                        </div>
                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={tandooriroti} className="card-img-top" alt="tandooriroti" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={chickenplate} className="card-img-top" alt="chickenplate" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={chickenkari} className="card-img-top" alt="chickenplate" />
                            </Zoom>
                        </div>
                       

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={ricemenu} className="card-img-top" alt="ricemenu" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={panerphoto} className="card-img-top" alt="panerphoto" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={chickenmenup} className="card-img-top" alt="chickenmenu" />
                            </Zoom>
                        </div>


                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={elishfish} className="card-img-top" alt="elishfish" />
                            </Zoom>
                        </div>


                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={foodp} className="card-img-top" alt="foodplate" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={motor} className="card-img-top" alt="motor" />
                            </Zoom>
                        </div>
                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={chickepakora} className="card-img-top" alt="chickepakora" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={biriyani} className="card-img-top" alt="biriyani" />
                            </Zoom>
                        </div>

                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={egg} className="card-img-top" alt="egg" />
                            </Zoom>
                        </div>
                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={kabab} className="card-img-top" alt="kabab" />
                            </Zoom>
                        </div>
                        <div className="col-md-4 mt-2">
                            <Zoom>
                                <img src={ricewithghee} className="card-img-top" alt="eggricewithghee" />
                            </Zoom>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default Food